import { WidgetProps, getTemplate } from '@rjsf/utils';
import { NodeColumnsInfo } from 'api/workflows-steps/formSchema';
import ColumnSelectorButton from './ColumnSelectorButton';

const ColumnFromFileWidget = function (props: WidgetProps) {
  const { options, registry } = props;
  const BaseInputTemplate = getTemplate('BaseInputTemplate', registry, options);

  const nodeColumns = (props.options['columns'] as NodeColumnsInfo[]) ?? [];

  return (
    <div className="flex items-center gap-1.5">
      <BaseInputTemplate {...props} className="grow" />
      <ColumnSelectorButton
        className="ms-1"
        size="medium"
        columns={nodeColumns}
        onSelect={(columnName) => props.onChange(columnName)}
        disabled={props.disabled}
        ariaLabel="select column"
      />
    </div>
  );
};

export { ColumnFromFileWidget };
